export enum Roles {
  SUPER_ADMIN = 'super_admin',
  HEAD = 'head',
  SEO_SPECIALIST = 'seo_specialist',
  ANALYST = 'analyst',
  DESIGNER = 'designer',
  ACCOUNTANT = 'accountant',
  CLIENT_SERVICE_HEAD = 'client_service_head',
  CLIENT_MANAGER = 'client_manager',
  LOGISTICIAN = 'logistician',
  CATEGORY_MANAGER = 'category_manager',
  SITE_ADMINISTRATOR = 'site_administrator',
  OBJECT_MANAGER = 'object_manager',
  SUPERVISOR = 'supervisor',
}

export interface IRoleOption {
  value: string;
  label: string;
}

// The assignable roles (excludes deprecated admin/manager) in display order.
// Labels are resolved client-side from the `common:roles.*` i18n namespace.
export const ASSIGNABLE_ROLES: Roles[] = [
  Roles.SUPER_ADMIN,
  Roles.HEAD,
  Roles.SEO_SPECIALIST,
  Roles.ANALYST,
  Roles.DESIGNER,
  Roles.ACCOUNTANT,
  Roles.CLIENT_SERVICE_HEAD,
  Roles.CLIENT_MANAGER,
  Roles.LOGISTICIAN,
  Roles.CATEGORY_MANAGER,
  Roles.SITE_ADMINISTRATOR,
  Roles.OBJECT_MANAGER,
  Roles.SUPERVISOR,
];

export enum AdminsEndpoints {
  PROFILE = '/profile',
  CHANGE_PASSWORD = '/profile/change-password',
  ORDER_MANAGERS = '/orders/managers',
}

export interface IManager {
  id: string;
  full_name: string;
  region_id?: string | null;
}

export interface IOrderManager extends IManager {
  region_id: string | null;
}

export interface IManagersListResponse {
  data: IOrderManager[];
}

export interface IAdminProfile {
  id: string;
  lastName: string;
  firstName: string;
  role: string;
  email: string;
  regionId: string | null;
  regionName: string;
  permissions: string[];
}

// ----------------- DTOs ----------------

export interface IAdminProfileDTO {
  last_name: string;
  first_name: string;
}

export interface IChangePasswordDTO {
  password: string;
  new_password: string;
  new_password_confirmation: string;
}

// ------------ Responses --------------

export interface IAdminProfileResponse {
  id: string;
  last_name: string;
  full_name: string;
  first_name: string;
  email: string;
  role: Roles;
  region_id: string | null;
  region: {
    id: string;
    name: string;
  } | null;
  permissions: string[];
  active: boolean;
  invitation_expired: boolean | null;
}

export interface IPartnerProfileResponse {
  id: string;
  last_name: string;
  first_name: string;
  phone: string;
  date: string;
  email: string;
  isActive: boolean;
  isVisible: boolean;
}

export interface IAdminProfileResponse {
  data: IAdminProfileResponse;
}
